import React, { useState } from "react";
import { PUT, POST, DELETE } from "../../../../constant/RequestAuthService";
import { Validation } from "../../../../constant/Util";
import * as Validator from "validatorjs";
import { toast } from "react-toastify";
import {
  PrimaryLoader,
  SecondaryLoader,
} from "../../../../component/button/Buttons";

export const AddUserRole = ({ handleClose, modal }) => {
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(!loading);
    const requestData = {
      role: role,
    };
    // console.log(requestData);
    const validation = new Validator(requestData, {
      role: "required",
    });
    if (validation.fails()) {
      await Validation(validation.errors.errors);
    } else {
      if (validation.passes()) {
        const response = await POST("admin/employee-type", requestData);
        if (response.status === 200) {
          toast.success(response.message);
          modal.refetch();
          setLoading(!loading);
        } else {
          toast.error(response.message);
        }
        handleClose();
      }
    }
  };
  return (
    <>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLongTitle">
          Add User Role
        </h5>
        <button
          onClick={() => handleClose()}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span style={{ fontSize: "33px" }} aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div className="modal-body">
        <small className="text-danger errorMess"> </small>
        <div className="form form-group">
          <label className="mt-3">
            <b>Role</b>
          </label>
          <input
            type="text"
            placeholder="Enter User Role"
            className="form-control mt-2"
            name="psw2"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="submit"
          data-dismiss="modal"
          className="btn bg-primary text-white w-100 mt-3"
          onClick={(e) => handleSubmit(e)}
        >
          Add
        </button>

        <button
          onClick={handleClose}
          className="btn bg-danger text-white w-100 mt-3"
          data-dismiss="modal"
        >
          Cancel
        </button>
      </div>
    </>
  );
};

export const EditUserRole = ({ handleClose, modal }) => {
  const [role, setRole] = useState(modal.x.role);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const requestData = {
      id: modal.x.id,
      role: role,
    };
    // console.log(requestData);
    const validation = new Validator(requestData, {
      role: "required",
    });
    if (validation.fails()) {
      await Validation(validation.errors.errors);
    } else {
      if (validation.passes()) {
        const response = await PUT("admin/employee-type", requestData);
        if (response.status === 200) {
          toast.success(response.message);
          modal.refetch();
          setLoading(false);
        } else {
          toast.error(response.message);
        }
        handleClose();
      }
    }
    setLoading(false);
  };
  return (
    <>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLongTitle">
          Edit User Role
        </h5>
        <button
          onClick={() => handleClose()}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span style={{ fontSize: "33px" }} aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div className="modal-body">
        <small className="text-danger errorMess"> </small>
        <div className="form form-group">
          <label className="mt-3">
            <b>Role</b>
          </label>
          <input
            id="empIdedit"
            readonly
            type="text"
            className="form-control mt-2"
            name="psw2"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="modal-footer">
        {loading === true ? (
          <PrimaryLoader />
        ) : (
          <button
            type="submit"
            data-dismiss="modal"
            className="btn bg-primary text-white w-100 mt-3"
            onClick={(e) => handleSubmit(e)}
          >
            Update
          </button>
        )}

        <button
          onClick={handleClose}
          className="btn bg-danger text-white w-100 mt-3"
          data-dismiss="modal"
        >
          Cancel
        </button>
      </div>
    </>
  );
};

export const DeleteUserRole = ({ handleClose, modal }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await DELETE("admin/employee-type", { id: modal.x.id });
    if (response.status === 200) {
      toast.success(response.message);
      setLoading(false);
      modal.refetch();
    } else {
      toast.error(response.message);
    }
    handleClose();
    setLoading(false);
  };
  return (
    <>
      <div className="modal-header mb-4">
        <h5 className="modal-title " id="exampleModalLongTitle">
          Delete User Role
        </h5>
        <button
          onClick={() => handleClose()}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span style={{ fontSize: "33px" }} aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div className="modal-body">
        <small className="text-danger errorMess"></small>
        <input id="deleteattendanceid" type="hidden" />
        <h6 className="text-center">
          Are You Sure You Want to Delete This User Role?
        </h6>
      </div>
      <div className="modal-footer">
        {loading === true ? (
          <SecondaryLoader />
        ) : (
          <button
            type="submit"
            data-dismiss="modal"
            className="btn bg-primary text-white w-100 mt-3"
            onClick={(e) => handleDelete(e)}
          >
            Yes
          </button>
        )}

        <button
          onClick={handleClose}
          className="btn bg-danger text-white w-100 mt-3"
          data-dismiss="modal"
        >
          No
        </button>
      </div>
    </>
  );
};
